import { HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { buildEnv } from 'build-environment';

const __PROJECT_NAME__: string = buildEnv.projectName;
const __BUILD_VERSION__: string = buildEnv.buildVersion;

export function HttpLoaderFactory(httpClient: HttpClient) {
  const resources = [{ prefix: './assets/i18n/', suffix: '.json?version=' + __BUILD_VERSION__ }];

  if (typeof __PROJECT_NAME__ !== 'undefined') {
    resources.push({
      prefix: './assets/projects/' + __PROJECT_NAME__ + '/i18n/',
      suffix: '.json?version=' + __BUILD_VERSION__,
    });
  }

  return new MultiTranslateHttpLoader(httpClient, resources);
}
